import percentChanged from "../../../../components/percentChanged/percentChanged";
import { connect } from "react-redux";

export default connect(state => ({
  changeValue: state.membershipDetails.statistics.churnRate.valueChange,
  toolTip: "Percentage change",
  showBorder: true,
  positiveColor: "#c7343e",
  negativeColor: "#21e981"
}))(percentChanged);
